/* W737 collection page v2 (approved prototype A "Find it fast", v25), staged on draft theme 164799152367.
   Behaviour ported from Agent OS/work/website-redesign/collection-page/build/proto.js, on the live store:
   every chip, colour and type choice is a Shopify native filter in the address (filter.p.m.custom.*); the page section
   is re-rendered by Shopify (Section Rendering API) so counts and products are always the store's own. Every control is
   also a plain link, so it works before this script loads. "Show me more" loads the next page of 36 into the grid and
   keeps loading by itself up to 108, then only on the button (as in the prototype).
   W737 revision (2026-10-03):
   - "Size, in inches" + "Shape" are theme-only filters in the address (size=8x12, shape=portrait|landscape; Shopify ignores
     them, so the native filters and sort stay exactly Shopify's). When one is on, the script reads the WHOLE collection for
     the current native filters and sort from the compact index (?view=tpjidx, 250 products a request), keeps the products
     whose own Size option has that size / that shape, and draws the count, "Show N results", pills and pages of 36 from
     that full list. Never filters only the cards already loaded. If the index cannot be read completely after retries,
     every chosen filter stays (address, history, buttons, pills) and the list area says so with "Try again"; no count
     and no unfiltered or partial cards are shown as the result (QA fix, 2026-10-03).
   - "Part of a set" marker on every single print listed in the verified snapshot assets/tpj-sets-index.json (also on
     cards added by "Show me more" and by the filters); it opens the native "From the same set" dialog, whose names,
     pictures, prices and availability are read live (?view=tpjmini). A set is shown only when the set and EVERY piece
     still load; otherwise it is left out, and a print with no showable set loses its marker.
   W857 (Ezra, 2026-10-13, Niv's ruling): the new gallery listings are the sets now. The marker goes on every print that a
   gallery lists, read live from templates/collection.tpjgal.liquid (no snapshot to rebuild when galleries are added),
   and the window shows that print's ONE gallery with all its artworks. The older sets are no longer shown. */
(function () {
  "use strict";
  var AUTO_MAX = 108;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = function () { return $("[data-tpjc]"); };
  if (!root()) return;
  var moreIO = null;
  /* Every filter/query change (chip, swatch, pill, clear, back/forward) starts a new "generation" and cancels what is
     in flight; a response is only applied while its generation is current AND it was asked for the query now in the
     address. So an old "Show me more" page can never land in a newly filtered grid or send the shopper back to the old
     query (QA fix, 2026-10-02). */
  var gen = 0, swapCtl = null, moreCtl = null, moreGen = -1;
  function abortable() { return "AbortController" in window ? new AbortController() : null; }
  function cancel(ctl) { if (ctl) { try { ctl.abort(); } catch (e) { /* ignore */ } } }
  function queryKey(url) {
    // the identity of a product list: collection path + native filters + sort (tracking/preview/page parameters ignored)
    var u = new URL(url, location.href), out = [];
    new URLSearchParams(u.search).forEach(function (v, k) {
      if (k.indexOf("filter.") === 0 || k === "sort_by" || k === "q") out.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
    });
    return u.pathname.replace(/\/$/, "") + "?" + out.sort().join("&");
  }
  var shownKey = queryKey(location.href);

  /* ---- Size / Shape (theme-only filters) ---- */
  var SIZE_KEYS = ["8x10", "8x12", "12x16", "12x18", "16x24", "18x24", "20x28", "20x30", "24x32", "24x36"];
  var SHAPE_CODE = { portrait: "p", landscape: "l" };
  var TX_PARAMS = ["size", "shape"];
  var IDX_PARALLEL = 4, STEP = 36; // index pages hold 250 products (templates/collection.tpjidx.liquid)
  var txShown = null;       // txKey of the list drawn from the index, or null while the grid is the store's own page
  var tx = null;            // { key, list, shown }
  var idxCache = {};        // queryKey -> Promise of { total, items }
  var helpHTML = null;      // the customise box, copied from the store's own first page
  function txOk() { var r = root(); return !!r && r.dataset.txOk === "true"; }
  function txState(url) {
    var p = new URL(url, location.href).searchParams, size = null, shapes = [];
    p.getAll("size").forEach(function (v) { if (!size && SIZE_KEYS.indexOf(v) >= 0) size = v; });
    p.getAll("shape").forEach(function (v) { if (SHAPE_CODE[v] && shapes.indexOf(v) < 0) shapes.push(v); });
    shapes.sort();
    return { size: size, shapes: shapes };
  }
  function txActive(url) { if (!txOk()) return false; var s = txState(url); return !!(s.size || s.shapes.length); }
  function txKey(url) { var s = txState(url); return queryKey(url) + "|" + (s.size || "") + "|" + s.shapes.join(","); }
  function tpl(name, vals) {
    var t = root().getAttribute("data-t-" + name) || "";
    Object.keys(vals).forEach(function (k) { t = t.split("%" + k + "%").join(String(vals[k])); });
    return t;
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  function withPreview(u) { if (preview && !u.searchParams.has("preview_theme_id")) u.searchParams.set("preview_theme_id", preview); return u; }
  function idxUrl(url, page) {
    // only what decides the product list (native filters, sort, search) + the index view and page
    var u = new URL(url, location.href), keep = new URLSearchParams();
    u.searchParams.forEach(function (v, k) { if (k.indexOf("filter.") === 0 || k === "sort_by" || k === "q") keep.append(k, v); });
    keep.set("view", "tpjidx"); keep.set("page", page);
    u.search = keep.toString(); u.hash = "";
    return withPreview(u).toString();
  }
  function wait(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }
  function getJSON(u, tries) {
    // retries a busy (429), failing (5xx) or dropped request; anything else is a real failure
    tries = tries || 3;
    return fetch(u, { credentials: "same-origin" }).then(function (res) {
      if (!res.ok) { var e = new Error("HTTP " + res.status); e.retry = res.status === 429 || res.status >= 500; throw e; }
      return res.text();
    }).then(function (t) { return JSON.parse(t); }).catch(function (err) {
      if (tries > 1 && (err.retry || err instanceof TypeError)) return wait(err.retry ? 1500 * (4 - tries) : 800).then(function () { return getJSON(u, tries - 1); });
      throw err;
    });
  }
  function pool(list, n, job) {
    // run job(item) for every item, n at a time; rejects on the first failure
    var i = 0, failed = null;
    function next() {
      if (failed || i >= list.length) return Promise.resolve();
      var item = list[i++];
      return job(item).then(next, function (e) { failed = e; throw e; });
    }
    var runners = [];
    for (var k = 0; k < Math.min(n, list.length); k++) runners.push(next());
    return Promise.all(runners);
  }
  function readIndex(url) {
    // one complete, coherent read: every page must agree on total and page count, all pages but the last must be full,
    // and the rows must be exactly `total` different products. Anything else (a short page, a product repeated across
    // pages because the catalog changed while reading) rejects the whole read: counts are never drawn from part of it.
    function bad(why) { throw new Error("incomplete index: " + why); }
    function okPage(j, n, first) {
      if (!j || typeof j !== "object" || j.page !== n || !Array.isArray(j.items)) bad("page " + n);
      if (first && (j.pages !== first.pages || j.total !== first.total)) bad("page " + n + " disagrees");
      j.items.forEach(function (it) { if (!Array.isArray(it) || typeof it[0] !== "string" || !it[0]) bad("row on page " + n); });
      return j;
    }
    return getJSON(idxUrl(url, 1)).then(function (first) {
      okPage(first, 1, null);
      var total = first.total, np = first.pages;
      if (typeof total !== "number" || total < 0 || total % 1 || typeof np !== "number" || np < 0 || np % 1) bad("counts");
      if (total > 0 ? np < 1 || !first.items.length : np > 1) bad("page count");
      var pages = [first], rest = [];
      for (var n = 2; n <= np; n++) rest.push(n);
      return pool(rest, IDX_PARALLEL, function (n) {
        return getJSON(idxUrl(url, n)).then(function (j) { pages[n - 1] = okPage(j, n, first); });
      }).then(function () {
        var seen = {}, items = [], rows = 0, per = first.items.length;
        pages.forEach(function (pg, i) {
          if (i < pages.length - 1 && pg.items.length !== per) bad("short page " + (i + 1));
          rows += pg.items.length;
          pg.items.forEach(function (it) { if (!seen[it[0]]) { seen[it[0]] = 1; items.push(it); } });
        });
        if (rows !== total || items.length !== total) bad(items.length + " different of " + total);
        return { total: total, items: items };
      });
    });
  }
  function loadIndex(url) {
    // the whole collection (for this native query) once per visit. An incoherent read is tried once more from the start
    // (the catalog may have changed while reading); if it still is not complete the load fails, and renderTx shows the
    // store's own list instead. A failed load is never cached, so the next size/shape click reads it afresh.
    var key = queryKey(url);
    if (idxCache[key]) return idxCache[key];
    var p = readIndex(url).catch(function (err) {
      if (!/^incomplete index/.test(err && err.message)) throw err;
      return wait(600).then(function () { return readIndex(url); });
    });
    idxCache[key] = p;
    p.catch(function () { if (idxCache[key] === p) delete idxCache[key]; });
    return p;
  }
  function txMatch(st) {
    var codes = st.shapes.map(function (s) { return SHAPE_CODE[s]; });
    return function (it) {
      if (st.size && (" " + it[8] + " ").indexOf(" " + st.size + " ") < 0) return false;
      if (codes.length && !codes.some(function (c) { return it[9].indexOf(c) >= 0; })) return false;
      return true;
    };
  }
  function imgW(src, w) { return src.replace(/([?&])width=\d+/, "$1width=" + w); }
  function cardHTML(it, eager) {
    // the same markup as snippets/tpj-coll2-card.liquid, from the same Liquid-computed words
    var img = it[2] ? '<img src="' + esc(imgW(it[2], 560)) + '" srcset="' + [280, 420, 560, 760].map(function (w) { return esc(imgW(it[2], w)) + " " + w + "w"; }).join(", ") +
      '" sizes="(min-width:1024px) 290px, (min-width:768px) 31vw, 46vw" alt="' + esc(it[3]) + '" width="560" height="560"' + (eager ? ' fetchpriority="high"' : ' loading="lazy"') + ">" : "";
    return '<li class="card" data-h="' + esc(it[0]) + '"' + (it[11] ? ' data-id="' + esc(it[11]) + '"' : "") + '><a href="' + esc(it[1]) + '"><span class="ph-wrap"><span class="ph">' + img + '</span></span><span class="nm">' + esc(it[4]) +
      '</span><span class="pr">' + esc(it[6]) + (it[7] ? ' · <span>' + esc(it[7]) + "</span>" : "") + "</span></a></li>";
  }
  function syncTx() {
    var r = root(); if (!r) return;
    var on = txOk() && "fetch" in window;
    ["#sizeSet", "#shapeSet"].forEach(function (s) { var f = $(s, r); if (f) f.hidden = !on; });
    var st = txState(location.href);
    $$("[data-tx]", r).forEach(function (b) {
      var pressed = b.dataset.tx === "size" ? st.size === b.dataset.v : st.shapes.indexOf(b.dataset.v) >= 0;
      b.setAttribute("aria-pressed", txActive(location.href) && pressed ? "true" : "false");
    });
  }
  var X_ICON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  /* Failure state words (QA fix, 2026-10-03): functional words for a list that could not be read, allowed for this state
     by the parent brief. Never a count, never the zero-results message. */
  var TX_FAIL = { msg: "Sorry, these results didn't load.", retry: "Try again", apply: "Show results" };
  function drawTxChrome(url, n) {
    // count, "Show N results", filter badge, pills and the empty state, all from the full filtered list;
    // n === null: the list could not be read, so no count is shown, only the chosen filters (pills, badge)
    var r = root(), failed = n === null, st = txState(url);
    var c = $("#count", r); if (c) c.textContent = failed ? "" : tpl("count", { n: n });
    var a = $("#applyBtn", r); if (a) a.textContent = failed ? TX_FAIL.apply : tpl("apply", { n: n });
    var fc = $("#fcount", r);
    if (fc) { var k = (+fc.dataset.n || 0) + (st.size ? 1 : 0) + st.shapes.length; fc.textContent = k; fc.hidden = !k; }
    var pills = $("#pills", r);
    if (pills) {
      $$(".pill[data-rmx]", pills).forEach(function (p) { p.remove(); });
      var add = [];
      if (st.size) add.push(["size", st.size, st.size.replace("x", " x ")]);
      st.shapes.forEach(function (s) { var b = $('[data-tx="shape"][data-v="' + s + '"]', r); add.push(["shape", s, b ? b.textContent : s]); });
      pills.insertAdjacentHTML("beforeend", add.map(function (o) {
        return '<button type="button" class="pill" data-rmx="' + o[0] + '" data-v="' + esc(o[1]) + '">' + esc(o[2]) + X_ICON + "</button>";
      }).join(""));
    }
    var e = $("#empty", r); if (e) e.hidden = failed || n > 0;
  }
  function showTxFail(url, focusSel) {
    // the chosen filters stay (address, history, pressed buttons, pills); the store's unfiltered cards and count are NOT
    // shown as their result. "Try again" re-reads the same address, without a new history entry.
    var r = root(), grid = $("#grid", r); if (!grid) return;
    tx = null; txShown = "!" + txKey(url); // never equal to a real txKey, so Back/Forward and every new choice redraw
    grid.innerHTML = '<li class="txfail" role="alert"><p>' + esc(TX_FAIL.msg) + '</p><button type="button" class="btn btn-primary" id="txRetry">' +
      esc(TX_FAIL.retry) + "</button></li>";
    var m = $(".more", r); if (m) { m.innerHTML = ""; m.hidden = true; }
    drawTxChrome(url, null);
    r.classList.remove("is-loading");
    syncTx(); watchMore();
    if (focusSel) { var f = $(focusSel, r); if (f) f.focus({ preventScroll: true }); }
  }
  function moreBlock() {
    var r = root(), m = $(".more", r);
    if (!m) {
      var res = $(".results", r); if (!res) return null;
      m = document.createElement("div"); m.className = "more"; res.appendChild(m);
    }
    return m;
  }
  function drawTxMore() {
    var m = moreBlock(); if (!m) return;
    var n = tx.list.length;
    m.hidden = n === 0 || n <= STEP;
    var note = tpl("more", { shown: tx.shown, total: n });
    var btn = tx.shown < n ? '<a class="btn btn-primary" id="moreBtn" href="' + esc(location.href) + '">' + esc(root().getAttribute("data-t-morebtn")) + "</a>" : "";
    m.innerHTML = btn + '<p class="more-note" id="moreNote">' + esc(note) + "</p>";
  }
  function renderTx(url, focusSel) {
    // draw the size/shape list for the address; the newest choice wins, an older answer is ignored
    var my = ++gen, r = root();
    cancel(moreCtl);
    r.classList.add("is-loading");
    syncTx();
    loadIndex(url).then(function (idx) {
      if (my !== gen || txKey(url) !== txKey(location.href) || queryKey(url) !== shownKey) return;
      var r2 = root(), grid = $("#grid", r2);
      if (!grid) return;
      tx = { key: txKey(url), url: url, list: idx.items.filter(txMatch(txState(url))), shown: 0 };
      tx.shown = Math.min(STEP, tx.list.length);
      var html = [];
      for (var k = 0; k < tx.shown; k++) { html.push(cardHTML(tx.list[k], k < 4)); if (k === 7 && tx.shown > 8 && helpHTML) html.push(helpHTML); }
      if (tx.shown && tx.shown <= 8 && helpHTML) html.push(helpHTML);
      grid.innerHTML = html.join("");
      txShown = tx.key;
      drawTxChrome(url, tx.list.length); drawTxMore();
      r2.classList.remove("is-loading");
      syncTx(); decorate(); watchMore();
      if (focusSel) { var f = $(focusSel, r2); if (f) f.focus({ preventScroll: true }); }
    }).catch(function () {
      // only the newest choice may show its failure; an older answer never changes a newer query
      if (my !== gen || txKey(url) !== txKey(location.href) || queryKey(url) !== shownKey) return;
      // the whole collection could not be read completely: keep every chosen filter and offer "Try again" (QA fix,
      // 2026-10-03; replaces dropping size/shape from the address)
      showTxFail(url, focusSel);
    });
  }
  function moreTx() {
    var r = root(), grid = $("#grid", r), btn = $("#moreBtn", r);
    if (!tx || !grid || txShown !== txKey(location.href) || tx.shown >= tx.list.length) return;
    var hadFocus = btn && document.activeElement === btn, start = tx.shown, end = Math.min(start + STEP, tx.list.length), html = [];
    for (var k = start; k < end; k++) html.push(cardHTML(tx.list[k], false));
    grid.insertAdjacentHTML("beforeend", html.join(""));
    tx.shown = end;
    drawTxMore(); decorate(); watchMore();
    if (hadFocus) {
      var first = $$("#grid > li.card", r)[start + 0];
      var nb = $("#moreBtn", r);
      if (nb) nb.focus({ preventScroll: true }); else if (first) { var a = first.querySelector("a[href]"); if (a) a.focus({ preventScroll: true }); }
    }
  }
  function txUrlWith(name, v) {
    // Size is one choice at a time (as in the prototype); Shape can be both
    var u = new URL(location.href), st = txState(location.href);
    u.searchParams.delete("page"); u.searchParams.delete("section_id");
    if (name === "size") { u.searchParams.delete("size"); if (st.size !== v) u.searchParams.set("size", v); }
    else {
      var on = st.shapes.indexOf(v) >= 0;
      u.searchParams.delete("shape");
      st.shapes.forEach(function (s) { if (s !== v) u.searchParams.append("shape", s); });
      if (!on) u.searchParams.append("shape", v);
    }
    return u.toString();
  }
  function goTx(url, focusSel) {
    history.pushState({ tpjc: 1 }, "", url);
    if (queryKey(url) !== shownKey) swap(url, false, focusSel);        // the store's own list must change first
    else if (txActive(url)) renderTx(url, focusSel);
    else swap(url, false, focusSel);                                     // size/shape off: back to the store's own list
  }

  /* ---- "Part of a set" marker and the "From the same set" window ---- */
  var SETI = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="5" width="7" height="10" rx="1"/><rect x="14" y="9" width="7" height="10" rx="1"/></svg>';
  var setsP = null, broken = {};
  var sheet = { tok: 0, opener: null, h: null };
  function galUrl(page) {
    var u = withPreview(new URL("/collections/all", location.href));
    u.searchParams.set("sort_by", "created-descending");
    u.searchParams.set("view", "tpjgal");
    u.searchParams.set("page", page);
    return u.toString();
  }
  function loadSets() {
    // W857 (2026-10-13): the live gallery list (templates/collection.tpjgal.liquid). Galleries are the newest listings, so
    // the next page is read only while galleries still reach the end of the page. A print belongs to ONE gallery: the
    // newest gallery that lists it.
    if (setsP) return setsP;
    if (!root()) return Promise.reject(new Error("no page"));
    var gals = [], byId = {};
    function take(j) {
      if (!j || !Array.isArray(j.items)) throw new Error("bad gallery list");
      j.items.forEach(function (row) {
        if (!Array.isArray(row) || !Array.isArray(row[0]) || !Array.isArray(row[1]) || typeof row[0][0] !== "string" || !row[1].length) return;
        var gi = gals.push({ card: row[0], arts: row[1] }) - 1;
        row[1].forEach(function (art) { var id = String(art[0]); if (!(id in byId)) byId[id] = gi; });
      });
      return j;
    }
    function page(n) {
      return getJSON(galUrl(n)).then(take).then(function (j) {
        if (j.last > 200 && n < j.pages && n < 4) return page(n + 1);
      });
    }
    setsP = page(1).then(function () { return { gals: gals, byId: byId }; });
    setsP.catch(function () { setsP = null; });
    return setsP;
  }
  var tabN = null;
  function tabCount() {
    // W857: the Sets tab shows the number of galleries, read live from the Sets page's own address (galleries only).
    // A theme with no gallery yet has no Sets tab on its prints page.
    var r = root(), a = r && $("#setsTab", r);
    if (!a) return;
    function show(n) {
      if (!n && a.getAttribute("aria-current") !== "page") { var nav = $("#ctabs", r); if (nav) nav.hidden = true; return; }
      a.textContent = tpl("tab", { n: n });
    }
    if (tabN !== null) { show(tabN); return; }
    var u = withPreview(new URL(a.getAttribute("href"), location.href));
    u.searchParams.set("view", "tpjidx"); u.searchParams.set("page", 1);
    getJSON(u.toString()).then(function (j) {
      if (!j || typeof j.total !== "number") return;
      tabN = j.total; if (root() === r && document.contains(a)) show(tabN); else tabCount();
    }).catch(function () { /* the tab keeps its plain name */ });
  }
  function decorate() {
    if (!root()) return;
    tabCount();
    loadSets().then(function (S) {
      var label = root().getAttribute("data-t-marker") || "";
      $$("#grid > li.card[data-h]", root()).forEach(function (li) {
        var h = li.dataset.h, id = li.dataset.id;
        if (li.querySelector(".marker") || !id || !(id in S.byId) || broken[h]) return;
        var nm = li.querySelector(".nm"), b = document.createElement("button");
        b.type = "button"; b.className = "marker"; b.dataset.sets = h; b.dataset.id = id;
        b.setAttribute("aria-haspopup", "dialog");
        b.setAttribute("aria-label", label + ": " + (nm ? nm.textContent : ""));
        b.innerHTML = SETI + esc(label);
        li.appendChild(b);
      });
    }).catch(function () { /* no marker without the gallery list */ });
  }
  function setBlock(set, pieces) {
    var soldOut = root().getAttribute("data-t-soldout") || "";
    var meta = (set[7] ? set[7] + " · " : "") + (set[10] ? set[6] : soldOut);
    var ph = function (it, w) { return '<span class="ph">' + (it[2] ? '<img src="' + esc(imgW(it[2], w)) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">' : "") + "</span>"; };
    return '<div class="setblock"><div class="setblock-top"><a href="' + esc(set[1]) + '" tabindex="-1" aria-hidden="true">' + ph(set, 300) + '</a><div><p class="nm">' + esc(set[4]) +
      '</p><p class="meta">' + esc(meta) + '</p><a class="btn btn-primary" href="' + esc(set[1]) + '">' + esc(root().getAttribute("data-t-setcta")) + "</a></div></div>" +
      '<ul class="pieces">' + pieces.map(function (p) {
        return '<li><a href="' + esc(p[1]) + '">' + ph(p, 240) + '<span class="nm">' + esc(p[4]) + "</span>" + (p[10] ? "" : '<span class="meta">' + esc(soldOut) + "</span>") + "</a></li>";
      }).join("") + "</ul></div>";
  }
  function sheetEl() { var r = root(); return r ? $("#setSheet", r) : null; }
  function openSets(h, btn) {
    // W857: the window shows the print's one gallery: its picture, name, price and "Shop the whole set", then every artwork
    // in it (each opens the gallery, where the pieces are chosen). All of it is read live from the store with the list.
    var dlg = sheetEl(), id = btn && btn.dataset.id;
    loadSets().then(function (S) {
      var gal = id && id in S.byId ? S.gals[S.byId[id]] : null;
      if (!gal) { broken[h] = 1; if (btn) btn.remove(); return; }
      if (!dlg || typeof dlg.showModal !== "function") { location.href = gal.card[1]; return; }
      sheet = { tok: sheet.tok + 1, opener: btn, h: h };
      var pieces = gal.arts.map(function (art) { return ["", gal.card[1], art[2], "", art[1], "", "", "", "", "", true]; });
      var sub = $("#sheetSub", dlg); if (sub) sub.textContent = tpl("setsub", { n: gal.arts.length });
      $("#sheetSets", dlg).innerHTML = setBlock(gal.card, pieces);
      bottomReserve(); // the window keeps clear of Shopify's preview bar (QA fix, 2026-10-03)
      if (!dlg.open) dlg.showModal();
      dlg.scrollTop = 0;
    });
  }
  function onSheetClose() {
    // focus goes back to the marker that opened the window (or its card, if the list was redrawn meanwhile)
    sheet.tok++;
    var o = sheet.opener;
    if (o && document.contains(o)) { o.focus({ preventScroll: true }); return; }
    var li = sheet.h && $('#grid > li.card[data-h="' + CSS.escape(sheet.h) + '"]', root());
    if (li) { var m = li.querySelector(".marker") || li.querySelector("a[href]"); if (m) m.focus({ preventScroll: true }); }
  }
  function closeSheet() { var d = sheetEl(); if (d && d.open) d.close(); }
  document.addEventListener("close", function (e) { if (e.target && e.target.id === "setSheet") onSheetClose(); }, true);

  /* keep the theme preview on every request (the draft is reviewed through ?preview_theme_id=) */
  var preview = new URLSearchParams(location.search).get("preview_theme_id");
  function withSection(url) {
    var u = new URL(url, location.href);
    TX_PARAMS.forEach(function (p) { u.searchParams.delete(p); }); // theme-only filters do not change the store's render
    u.searchParams.set("section_id", root().dataset.section);
    if (preview && !u.searchParams.has("preview_theme_id")) u.searchParams.set("preview_theme_id", preview);
    return u.toString();
  }
  function pageUrl(params) {
    var u = new URL(location.href);
    u.search = params.toString();
    return u.toString();
  }

  /* ---- filters in the address ---- */
  function currentParams() { var p = new URLSearchParams(location.search); p.delete("page"); p.delete("section_id"); return p; }
  function without(params, name, values) {
    var out = new URLSearchParams();
    params.forEach(function (v, k) { if (!(k === name && values.indexOf(v) >= 0)) out.append(k, v); });
    return out;
  }
  function toggled(el) {
    // on/off is read from the address (the truth), so a second click before the page re-renders still toggles correctly
    var name = el.dataset.fp, values = el.dataset.v.split("||"), p = currentParams();
    var on = p.getAll(name).some(function (v) { return values.indexOf(v) >= 0; });
    if (on) return without(p, name, values);
    p = without(p, name, values);
    values.forEach(function (v) { p.append(name, v); });
    return p;
  }
  function cleared() {
    var out = new URLSearchParams();
    currentParams().forEach(function (v, k) { if (k.indexOf("filter.") !== 0 && TX_PARAMS.indexOf(k) < 0) out.append(k, v); });
    // W857: a Sets page keeps its galleries-only filter through "Clear all"
    new URLSearchParams(root().getAttribute("data-keep") || "").forEach(function (v, k) { out.append(k, v); });
    return out;
  }

  /* ---- re-render the section from the store ---- */
  function swap(url, push, focusSel) {
    // the newest request wins: older filter renders and any "Show me more" in flight are cancelled and ignored
    var my = ++gen;
    cancel(swapCtl); cancel(moreCtl);
    var ctl = swapCtl = abortable();
    url = new URL(url, location.href).toString();
    // the address changes at once, so the next click builds on this choice and Back returns to the previous one
    if (push && url !== location.href) history.pushState({ tpjc: 1 }, "", url);
    root().classList.add("is-loading");
    if (txActive(url)) loadIndex(url).catch(function () { /* handled by renderTx */ }); // read the index alongside
    fetch(withSection(url), ctl ? { credentials: "same-origin", signal: ctl.signal } : { credentials: "same-origin" }).then(function (res) {
      if (!res.ok) throw new Error(res.status);
      return res.text();
    }).then(function (html) {
      if (my !== gen || queryKey(url) !== queryKey(location.href)) return;
      var doc = new DOMParser().parseFromString(html, "text/html"), fresh = $("[data-tpjc]", doc);
      if (!fresh) throw new Error("no section");
      var cur = root(), panelOpen = $("#fpanel", cur) && $("#fpanel", cur).classList.contains("is-open");
      closeSheet();
      cur.innerHTML = fresh.innerHTML;
      cur.classList.remove("is-loading");
      shownKey = queryKey(url);
      txShown = null; tx = null;
      gen++; // a "Show me more" started against the old grid during this render is now stale too
      setup();
      if (panelOpen) openPanel(true, true);
      // size/shape on: the store's list is replaced by the full-collection size/shape list before it is shown
      if (txActive(location.href)) { renderTx(location.href, focusSel); return; }
      if (focusSel) { var f = $(focusSel, cur); if (f) f.focus({ preventScroll: true }); }
    }).catch(function (err) {
      if (my !== gen || (err && err.name === "AbortError")) return;
      location.href = url;
    }).then(function () { if (swapCtl === ctl) swapCtl = null; });
  }
  function focusSelFor(el) {
    if (!el.dataset.fp) return null;
    return '[data-fp="' + el.dataset.fp + '"][data-v="' + CSS.escape(el.dataset.v) + '"]';
  }

  /* ---- "Show me more": next page of 36 into the grid ---- */
  function loadMore() {
    var r = root(), btn = $("#moreBtn", r), grid = $("#grid", r);
    // nothing to load, a page already on its way, or a filter render in flight (its grid replaces this one)
    if (!btn || !grid || moreGen === gen || swapCtl || r.classList.contains("is-loading")) return;
    var href = btn.href;
    // only a next page of the query in the address (and on screen) is accepted
    if (queryKey(href) !== queryKey(location.href) || queryKey(href) !== shownKey) return;
    var my = moreGen = gen, ctl = moreCtl = abortable();
    var stale = function () {
      var c = root();
      return my !== gen || queryKey(href) !== queryKey(location.href) || queryKey(href) !== shownKey ||
        $("#grid", c) !== grid || $("#moreBtn", c) !== btn;
    };
    fetch(withSection(href), ctl ? { credentials: "same-origin", signal: ctl.signal } : { credentials: "same-origin" }).then(function (res) {
      if (!res.ok) throw new Error(res.status);
      return res.text();
    }).then(function (html) {
      if (stale()) return;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var cards = $$("#grid > li.card", doc), first = null;
      cards.forEach(function (li) { var n = document.importNode(li, true); grid.appendChild(n); if (!first) first = n; });
      decorate();
      var nb = $("#moreBtn", doc), nn = $("#moreNote", doc), note = $("#moreNote", root());
      // the store's own "Showing N of M" for the page just added; it stays after the last page (QA fix, 2026-10-02)
      if (note && nn) note.textContent = nn.textContent;
      if (nb) btn.href = nb.getAttribute("href");
      else {
        var hadFocus = document.activeElement === btn;
        btn.remove();
        if (hadFocus && first) { var a = first.querySelector("a[href]"); if (a) a.focus({ preventScroll: true }); }
      }
    }).catch(function (err) {
      if (err && err.name === "AbortError") return;
      if (!stale()) location.href = href;
    }).then(function () {
      if (moreGen === my) moreGen = -1;
      if (moreCtl === ctl) moreCtl = null;
      if (my === gen) watchMore();
    });
  }
  function shownCount() { return $$("#grid > li.card", root()).length; }
  function more() { if (txShown && txShown === txKey(location.href)) moreTx(); else if (!txShown) loadMore(); }
  function watchMore() {
    if (moreIO) moreIO.disconnect();
    var m = $(".more", root());
    if (!m || !$("#moreBtn", m) || !("IntersectionObserver" in window)) return;
    moreIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && shownCount() < AUTO_MAX) more(); });
    }, { rootMargin: "0px 0px 600px 0px" });
    moreIO.observe(m);
  }

  /* ---- filter panel: a sheet on phones, a side column from 1024px ---- */
  /* Shopify's theme-preview bar sits in the browser's top layer over the bottom of the screen, above any z-index. The
     sheet keeps that much room free at its foot so "Show N results" stays visible and clickable. No bar (the live
     store) = no extra room. (QA fix, 2026-10-02) */
  function bottomReserve() {
    var r = root(), bar = $("#PBarNextFrameWrapper"), px = 0;
    if (bar) {
      var b = bar.getBoundingClientRect();
      if (b.height > 0 && b.top < innerHeight) px = Math.min(innerHeight - b.top, Math.round(innerHeight * 0.4));
    }
    var v = Math.max(0, Math.ceil(px)) + "px";
    if (r && r.style && r.style.getPropertyValue("--tpjc-bottom-ui") !== v) r.style.setProperty("--tpjc-bottom-ui", v);
  }
  /* QA fix (2026-10-03): the same room is kept on every surface, not only the opening phone sheet: the desktop sticky
     filter column (so "Clear all" is not under the bar) and the set window. Measured at start, on resize, whenever the
     bar is added, resized or collapsed, and again on each open. The live store has no bar, so the room stays 0 px. */
  window.addEventListener("resize", bottomReserve);
  (function watchBar() {
    var seen = null, ro = "ResizeObserver" in window ? new ResizeObserver(bottomReserve) : null;
    function look() {
      var bar = $("#PBarNextFrameWrapper");
      if (bar && bar !== seen) { if (ro) { if (seen) ro.unobserve(seen); ro.observe(bar); } seen = bar; }
      bottomReserve();
    }
    look();
    if ("MutationObserver" in window && document.body) {
      var mo = new MutationObserver(look);
      mo.observe(document.body, { childList: true, subtree: true }); // collapse/resize of the bar itself: ResizeObserver
      setTimeout(function () { mo.disconnect(); look(); }, 15000); // the bar is added once, soon after load
    }
    window.addEventListener("load", look);
  })();
  function openPanel(on, quiet) {
    var r = root(), p = $("#fpanel", r); if (!p) return;
    if (on) bottomReserve();
    p.classList.toggle("is-open", on); $("#scrim", r).hidden = !on;
    $("#openFilters", r).setAttribute("aria-expanded", on);
    if (quiet) return;
    if (on) $("#closeFilters", r).focus(); else $("#openFilters", r).focus();
  }

  /* ---- description: 2 lines on phones, "More" opens the rest (prototype round 3) ---- */
  function clampIntro() {
    var i = $("#cIntro", root()), b = $("#introMore", root()); if (!i || !b) return;
    i.classList.add("is-clamped"); b.setAttribute("aria-expanded", "false");
    var p = i.querySelector("p");
    b.hidden = !p || !(p.scrollHeight > p.clientHeight + 1 || i.querySelectorAll("p").length > 1);
    if (b.hidden) i.classList.remove("is-clamped");
  }

  function setup() {
    var hb = $("#grid > li.helpbox", root());
    if (hb) helpHTML = hb.outerHTML;
    clampIntro();
    watchMore();
    syncTx();
    decorate();
    // the kids article keeps the store's words and links; its old inline layout styles are dropped (as in the prototype)
    $$("#kids [style]", root()).forEach(function (el) { el.removeAttribute("style"); });
  }

  document.addEventListener("click", function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    var b = e.target.closest("a, button"); if (!b || !r.contains(b)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (b.dataset.sets) { e.preventDefault(); openSets(b.dataset.sets, b); return; }
    if (b.hasAttribute("data-close")) { closeSheet(); return; }
    // "Try again" after a failed read: the same address, no new history entry, a fresh read (failed reads are not cached)
    if (b.id === "txRetry") { e.preventDefault(); if (txActive(location.href)) renderTx(location.href, "#grid a[href], #txRetry"); else swap(location.href, false); return; }
    if (b.dataset.tx) { e.preventDefault(); goTx(txUrlWith(b.dataset.tx, b.dataset.v), '[data-tx="' + b.dataset.tx + '"][data-v="' + CSS.escape(b.dataset.v) + '"]'); return; }
    if (b.dataset.rmx) { e.preventDefault(); goTx(txUrlWith(b.dataset.rmx, b.dataset.v), "#pills"); return; }
    if (b.dataset.fp) { e.preventDefault(); swap(pageUrl(toggled(b)), true, focusSelFor(b)); return; }
    if (b.dataset.rm) { e.preventDefault(); swap(pageUrl(without(currentParams(), b.dataset.rm, b.dataset.v.split("||"))), true, "#pills"); return; }
    if (b.id === "clearAll" || b.id === "emptyClear") { e.preventDefault(); swap(pageUrl(cleared()), true); return; }
    if (b.id === "moreBtn") { e.preventDefault(); more(); return; }
    if (b.id === "openFilters") { openPanel(true); return; }
    if (b.id === "closeFilters" || b.id === "applyBtn") { openPanel(false); return; }
    if (b.id === "introMore") { $("#cIntro", r).classList.remove("is-clamped"); b.setAttribute("aria-expanded", "true"); b.hidden = true; return; }
  });
  document.addEventListener("click", function (e) {
    if (e.target.id === "scrim" && root().contains(e.target)) openPanel(false);
    if (e.target.id === "setSheet") closeSheet(); // a click on the dimmed backdrop closes the window
  });
  document.addEventListener("keydown", function (e) {
    var r = root(); if (!r) return;
    if (e.key === "Escape" && $("#fpanel", r) && $("#fpanel", r).classList.contains("is-open")) openPanel(false);
    // chips and swatches are links that act as toggle buttons: Space presses them too
    if (e.key === " " && e.target.matches && e.target.matches('a[role="button"]') && r.contains(e.target)) { e.preventDefault(); e.target.click(); }
  });
  window.addEventListener("popstate", function () {
    closeSheet();
    if (queryKey(location.href) !== shownKey) { swap(location.href, false); return; }
    // same store list, different size/shape choice: redraw from the index, or go back to the store's own list
    var tk = txActive(location.href) ? txKey(location.href) : null;
    if (tk !== txShown) { if (tk) renderTx(location.href); else swap(location.href, false); return; }
    // back to the list already on screen while a filter render or size/shape read was on its way: drop it (its answer
    // is now stale), and set the pressed Size/Shape buttons back from the address (QA fix, 2026-10-03). Count, pills and
    // cards were not touched by the dropped request, so they already show this list.
    if (swapCtl || root().classList.contains("is-loading")) {
      gen++; cancel(swapCtl); swapCtl = null; root().classList.remove("is-loading");
    }
    syncTx();
  });
  setup();
  if (txActive(location.href)) renderTx(location.href); // a shared or reloaded size/shape address
})();
